module.exports = __webpack_public_path__ + "static/img/content_bg_id.4ef440a9.png";